module.exports = __webpack_public_path__ + "static/media/instagram.ff5f5b08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/components/Social/images/instagram.svg
// module id = 811
// module chunks = 0